"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _VisitedOffersFrame = require("./VisitedOffersFrame");
Object.keys(_VisitedOffersFrame).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VisitedOffersFrame[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VisitedOffersFrame[key];
    }
  });
});